import {
  Lazy, Navigation, Pagination, Swiper,
} from 'swiper';
import { getBreakpoints } from '../utils/utils';

let width = window.innerWidth;

function closeItems(block) {
  block.querySelectorAll('.item-offer').forEach((item) => {
    if (item.querySelector('.item-offer__text')) {
      if (item.querySelector('.offer-slider__navigation')) {
        item.querySelector('.offer-slider__navigation').classList.add('d-none');
      }
      item.querySelector('.item-offer__text').classList.remove('d-none');
      item.querySelector('.item-offer__slider').classList.remove('active');
      item.querySelector('.item-offer__blackout').classList.remove('d-none');
      item.querySelector('.item-offer__diamond').classList.add('d-none');
      block.querySelectorAll('.item-offer-details').forEach((details) => {
        details.classList.add('d-none');
      });
    }
  });
}

window.addEventListener('resize', () => {
  if (width !== window.innerWidth) {
    document.querySelectorAll('.offers-block').forEach((block) => {
      closeItems(block);
    });
  }
});

function setCount() {
  width = window.innerWidth;

  switch (true) {
    case width < getBreakpoints().xl && width > getBreakpoints().lg:
      return 2;
    case width < getBreakpoints().lg:
      return 1;
    default:
      return 3;
  }
}

function openItem(block, index, offer) {
  offer.querySelector('.item-offer__text').classList.add('d-none');
  if (offer.querySelector('.offer-slider__navigation')) {
    offer.querySelector('.offer-slider__navigation').classList.remove('d-none');
  }
  offer.querySelector('.item-offer__blackout').classList.add('d-none');
  offer.querySelector('.item-offer__slider').classList.add('active');
  offer.querySelector('.item-offer__diamond').classList.remove('d-none');
  const selectedIndex = block.querySelectorAll('.item-offer-details')[index];
  selectedIndex.classList.remove('d-none');
  selectedIndex.style.order = setCount() * Math.ceil((index + 1) / setCount()) + 1;
  window.location.hash = offer.id;
}

document.querySelectorAll('.offers-block').forEach((block) => {
  block.querySelectorAll('.item-offer-details').forEach((offerDetails) => {
    offerDetails.querySelector('.item-offer-details__close').addEventListener('click', (event) => {
      event.preventDefault();
      closeItems(block);
    });
  });

  block.querySelectorAll('.item-offer').forEach((slider, index) => {
    // eslint-disable-next-line no-param-reassign
    slider.style.order = index + 1;
    slider.addEventListener('click', function () {
      closeItems(block);
      openItem(block, index, this);
    });

    slider.addEventListener('keydown', function (event) {
      if (event.keyCode === 13) {
        closeItems(block);
        openItem(block, index, this);
      }
    });
  });
});

document.querySelectorAll('.offer-slider').forEach((slider) => {
  const swiper = new Swiper(slider, {
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    loop: true,
    autoHeight: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.querySelector('.offer-slider__btn--next'),
      prevEl: slider.querySelector('.offer-slider__btn--prev'),
    },
    pagination: {
      clickable: true,
      el: slider.querySelector('.offer-slider__pagination'),
    },
    modules: [Lazy, Pagination, Navigation],
    on: {
      beforeInit() {
        const numberOfSlides = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate )').length;
        if (numberOfSlides <= 1) {
          this.params.loop = false;
        }
      },
    },
  });

  slider.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
    bullet.setAttribute('tabindex', 0);
    bullet.setAttribute('id', index);
    bullet.addEventListener('keydown', function (event) {
      if (event.keyCode === 13) {
        const slideID = this.getAttribute('id');
        swiper.slideToLoop(slideID);
      }
    });
  });
});

function openAnchoredOffer() {
  // An empty hash makes querySelector throw; it also happens when the script
  // is delayed (Perfmatters) and its re-dispatched DOMContentLoaded runs here.
  if (!window.location.hash) {
    return;
  }
  const anchor = window.document.querySelector(window.location.hash);
  if (anchor) {
    anchor.click();
  }
}

if (document.readyState === 'loading') {
  window.document.addEventListener('DOMContentLoaded', openAnchoredOffer);
} else {
  openAnchoredOffer();
}

window.addEventListener('hashchange', openAnchoredOffer);
export default true;
